var _desc, _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconUploadnewversion(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "18px",
    height: "13px",
    viewBox: "0 0 18 13",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icon_uploadnewversion") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M16.0049107,1 C17.1067681,1 18,1.90195036 18,3.0085302 L18,10.9914698 C18,12.1007504 17.1073772,13 16.0049107,13 L1.99508929,13 C0.893231902,13 0,12.0980496 0,10.9914698 L0,3.0085302 C0,1.8992496 0.892622799,1 1.99508929,1 L5,1 L5,3 L2,3 L2,11 L16,11 L16,3 L13,3 L13,1 L16.0049107,1 Z M9,0 C9.55228475,0 10,0.437881351 10,1.00292933 L10,5.585 L10.29325,5.2925 C10.65325,4.9325 11.2211553,4.90480769 11.6139273,5.20942308 L11.70825,5.2925 C12.09725,5.6835 12.09725,6.3175 11.70825,6.7075 L11.70825,6.7075 L9.71125,8.7035 C9.51425,8.9005 9.25725,9.0015 8.99925,9.0015 C8.74425,9.0015 8.48825,8.9025 8.28825,8.7035 L8.28825,8.7035 L6.29325,6.7075 C5.90225,6.3175 5.90225,5.6835 6.29325,5.2925 C6.68425,4.9025 7.31625,4.9025 7.70725,5.2925 L7.70725,5.2925 L8,5.585 L8,1.00292933 C8,0.488591225 8.38272018,0.0646817601 8.88266744,0.00674743907 L9,0 Z",
    id: "path-1"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon_uploadnewversion",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("use", {
    id: "Combined-Shape",
    fill: "#E3EDF3",
    fillRule: "nonzero",
    transform: "translate(9.000000, 6.500000) rotate(-180.000000) translate(-9.000000, -6.500000) ",
    xlinkHref: "#path-1"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconUploadnewversion);
export default __webpack_public_path__ + "static/media/icon_uploadnewversion.da2386e4c9ff282e176e73bf0c111d74.svg";
export { ForwardRef as ReactComponent };